<template>
  <div>
    <div class="form-check" :class="[{ disabled: disabled }, inlineClass]">
      <label :for="cbId" class="form-check-label">
        <input
          :id="cbId"
          class="form-check-input"
          type="checkbox"
          :disabled="disabled"
          v-model="model"
        />
        <span class="form-check-sign"></span><slot></slot>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  name: 'base-checkbox',
  model: {
    prop: 'checked'
  },
  props: {
    checked: Boolean,
    disabled: Boolean,
    inline: Boolean,
    hspResponseId: Number,
    isExclusive: Boolean,
    textValue: {
      type: String
    }
  },
  data() {
    return {
      cbId: ''
    };
  },
  computed: {
    model: {
      get() {
        return this.checked;
      },
      set(check) {
        this.$emit('input', check, {
          hspResponseId: this.hspResponseId,
          isExclusive: this.isExclusive
        });
      }
    },
    inlineClass() {
      if (this.inline) {
        return `form-check-inline`;
      }

      return '';
    }
  },
  created() {
    this.cbId = Math.random()
      .toString(16)
      .slice(2);
  }
};
</script>
<style scoped>
.form-check-inline input[type="checkbox"] {
  position: relative;
}
.form-check-inline .form-check-label {
  padding-left: 0px;
}
.form-check-inline {
  margin-right: 0px;
}
.form-check-inline .form-check-input {
  margin-right: 0px;
}
.form-check-radio.form-check-inline .form-check-label {
  margin-right: 0px;
}
</style>
